module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_04.711c5da2.jpg";